import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { CheckBoxPadrao, DatePickerPadrao, DelIcon, InputPadrao, LabelPadrao, ModalPadrao, OkIcon, ReturnIcon } from "../../components/Base";
import TabelaPadrao from "../../components/TabelaPadrao";
import dayjs from "dayjs";
import VendaDetalhe from "./VendaDetalhe";
import SelectFiltros from "../../components/Selects/SelectFiltros";
import { Menu, Popover, Radio } from "antd";
import { BtnFiltros, BtnListar, BtnPadrao, BtnSair } from "../../components/Buttons";
import ScrollContainer from "../../components/ScrollContainer";
import { useScroll } from "../../components/Hooks/useScroll";
import { DrawerPadrao } from "../../components/DialogPadrao";
import SelectPesq from "../../components/Selects/SelectPesq";
import getCssVariable from "../../Utils/getCssVariable";
import culture from "../../Utils/Culture";

function VendaConsultaModal({ visible, onCancel, ...props }) {
  const INITIAL_STATE = { periodo: dayjs(), isLocal: true, isNotCancelada: true, isCancelada: false, usuarioId: null };
  const [filtros, setFiltros] = useState(INITIAL_STATE);
  const [vendas, [listar, listarMais, loadingMais], [totais, loadingTotais]] = useScroll(props.fetch, "venda/consulta", filtros, { filtros: filtros, rota: "venda/consulta-tot", initial: { valorTotal: 0, valorProdutos: 0, qtd: 0, desconto: 0 } });
  const [detalhe, setDetalhe] = useState(null);
  const [showFiltros, setShowFiltros] = useState(false);

  useEffect(() => {
    if (!visible) {
      setDetalhe(null);
      setFiltros(INITIAL_STATE);
    }
    else
      listar();

  }, [filtros.isLocal, visible]);

  const columns = [
    { Header: "Data", accessor: "data", tipo: "dthr", Footer: `${vendas?.length} / ${totais.qtd}` },
    {
      Header: "Status", accessor: "status", Cell: props => {
        const isCancelada = !!props.row.original.dataCan;
        if (props.row.original.isDevolucao)
          return <ReturnIcon style={{ color: isCancelada && getCssVariable("--vermelho-padrao") }} />;
        else if (isCancelada)
          return <DelIcon />;
        else
          return <OkIcon />;

      }, tipo: "center"
    },
    { Header: "Número", accessor: "numero" },
    { Header: "Nota fiscal", accessor: "nf" },
    { Header: "Cliente", accessor: "cliente" },
    { Header: "Valor produtos", accessor: "valorProdutos", tipo: "rs", Footer: `R$ ${culture.format(totais.valorProdutos)}` },
    { Header: "Descontos", accessor: "desconto", tipo: "rs", Footer: `R$ ${culture.format(totais.desconto)}` },
    { Header: "Acréscimos", accessor: "acrescimo", tipo: "rs", Footer: `R$ ${culture.format(totais.acrescimo)}` },
    { Header: "Frete", accessor: "valorFrete", tipo: "rs", Footer: `R$ ${culture.format(totais.valorFrete)}` },
    { Header: "Valor total", accessor: "valorTotal", tipo: "rs", Footer: `R$ ${culture.format(totais.valorTotal)}` },
  ];

  const menu = <Menu>
    <Menu.Item>
      <CheckBoxPadrao checked={filtros.isNotCancelada} onChange={() => setFiltros({ ...filtros, isNotCancelada: !filtros.isNotCancelada })}>Vendas</CheckBoxPadrao>
    </Menu.Item>
    <Menu.Item>
      <CheckBoxPadrao checked={filtros.isCancelada} onChange={() => setFiltros({ ...filtros, isCancelada: !filtros.isCancelada })}>Canceladas</CheckBoxPadrao>
    </Menu.Item>
  </Menu>;

  return <ModalPadrao title="Venda consulta" visible={visible} onCancel={onCancel} footer={<BtnSair onClick={onCancel} />} width={window.innerWidth < 1200 ? window.innerWidth : 1200} >
    <div style={{ minHeight: 500 }}>
      <div style={{ width: "100%", display: "flex", alignItems: "flex-end" }}>
        <div style={{ width: "30%" }}>
          <LabelPadrao noMargin>Buscar pelo número/NF</LabelPadrao>
          <InputPadrao placeholder="Pesquisar" value={filtros.txt} onChange={v => setFiltros({ ...filtros, txt: v.target.value })} />
        </div>
        <div style={{ margin: "0 10px", width: "35%" }}>
          <SelectPesq noMargin placeholder="Selecione o cliente" title="Cliente" modelo="cliente" value={filtros.pessoa} onChange={v => setFiltros({ ...filtros, pessoa: v })} />
        </div>
        <div style={{ width: "15%", display: "flex", flexDirection: "column" }}>
          <LabelPadrao noMargin>Dia</LabelPadrao>
          <DatePickerPadrao value={filtros.periodo} onChange={dt => setFiltros({ ...filtros, periodo: dt })} />
        </div>
        <div style={{ width: "20%", margin: "0 10px", marginRight: 10 }}>
          <LabelPadrao noMargin style={{ paddingBottom: 10 }}>Local de pesquisa</LabelPadrao>
          <Radio.Group onChange={v => setFiltros({ ...filtros, isLocal: v.target.value })} value={filtros.isLocal}>
            <Radio value={true}>Local</Radio>
            <Radio disabled={!props.online} value={false}>Site</Radio>
          </Radio.Group>
        </div>
        <BtnFiltros style={{ marginRight: 10 }} onClick={() => setShowFiltros(true)} />
        <BtnListar onClick={listar} />
      </div>

      <ScrollContainer listar={listarMais} loading={loadingMais}>
        <div className="tabela-wrapper-zero">
          <TabelaPadrao style={{ marginTop: 20 }} columns={columns} data={vendas} setEdit={v => setDetalhe(v.id)} hideSemDados={loadingMais} />
        </div>
      </ScrollContainer>
    </div>

    <DrawerPadrao title="Filtros" placement="left" onClose={() => setShowFiltros(false)} visible={showFiltros} width={400}>
      <SelectFiltros noMargin allowClear title="Caixa" placeholder="Selecione o caixa" modelo="usuario" value={filtros.usuarioId} onChange={v => setFiltros({ ...filtros, usuarioId: v })} />
      <Popover content={menu} placement="bottom">
        <BtnPadrao style={{ display: "block", margin: "20px 0", width: "100%" }}>Tipo</BtnPadrao>
      </Popover>
    </DrawerPadrao>

    <ModalPadrao visible={!!detalhe} footer={<BtnSair onClick={() => setDetalhe(null)} />} onCancel={() => setDetalhe(null)} width={890}>
      {detalhe && <VendaDetalhe id={detalhe} isLocal={filtros.isLocal} onCancel={() => setDetalhe(null)} onOk={() => { setDetalhe(null); listar(); }} enableEdit />}
    </ModalPadrao>

  </ModalPadrao>;
}

const mapStateToProps = state => ({ online: state.connection.online });

export default connect(mapStateToProps, { fetch })(VendaConsultaModal);

